<template>
    <div v-if="initialized">
        <h3>Category</h3>
        <el-form-item v-for="category in filterCategories" :label="category" :key="category" class="pl-10 pb-10">
            <template v-for="(filter, index) in formValues[category]">
                <el-checkbox @change="updateFormValues(category, index)"
                             v-model="formValues[category][index].checked"
                             :label="filter.name"
                             :disabled="filter.dependsOn >= 0 && !formValues[category][filter.dependsOn].checked"
                             :class="[`indent-${filter.tree}`]"/>
                <br>
            </template>
        </el-form-item>
    </div>
</template>

<script>
    export default {
        props: {
            jobId: { type: Number, required: true },
            value: { type: Object, required: true },
        },
        data() {
            return {
                initialized: false,
                formValues: this.value,
                filterCategories: {},
                valueForDefaultPricing: {
                    categoryName: 'Job Category',
                    filterName: 'Owner Operators',
                },
            };
        },
        mounted() {
            axios.get(url(`/admin/jobs/load-form-categories-data?jobId=${this.jobId}`))
                 .then(response => {
                     if (response.status !== 200 ||
                         typeof response.data.filterCategories === 'undefined' ||
                         typeof response.data.filters === 'undefined') {

                         throw Error('Job categories could not be loaded.');
                     }

                     this.filterCategories = response.data.filterCategories;
                     this.formValues = response.data.filters;

                     this.initialized = true;
                     this.$emit('initialize', 'categories');

                     this.formValues['Job Category'].forEach((filter, index) => {
                         if (filter.name === 'Owner Operators') {
                             this.updateFormValues('Job Category', index);
                         } else if (filter.name === 'Lease Purchase') {
                             this.updateFormValues('Job Category', index);
                         }
                     });

                     this.formValues['Equipment Type'].forEach((filter, index) => {
                        if (filter.name === 'Tanker') {
                            this.updateFormValues('Equipment Type', index);
                        }
                     });

                     this.formValues['Teams'].forEach((filter, index) => {
                        if (filter.name === 'Team') {
                            this.updateFormValues('Teams', index);
                        }
                     });

                     this.formValues['Specialization'].forEach((filter, index) => {
                        if (filter.name === 'HazMat') {
                            this.updateFormValues('Specialization', index);
                        }
                     });
                 })
                 .catch(err => { this.$emit('error', err.message); });
        },
        methods: {
            updateFormValues(categoryName, filterIndex) {

                const isChecked = this.formValues[categoryName][filterIndex].checked;
                if (!isChecked) {
                    for(let i = 0; i < this.formValues[categoryName].length; i++) {
                        if (parseInt(this.formValues[categoryName][i].dependsOn) === parseInt(filterIndex)) {
                            this.$set(this.formValues[categoryName][i], 'checked', false);
                        }
                    }
                }

                this.$emit('input', this.formValues);
                if (categoryName === 'Job Category') {
                    if (this.formValues[categoryName][filterIndex].name === 'Owner Operators') {
                        this.$emit('updateOwnerOperators', this.formValues[categoryName][filterIndex].checked);
                    } else if (this.formValues[categoryName][filterIndex].name === 'Lease Purchase') {
                        this.$emit('updateLeasePurchase', this.formValues[categoryName][filterIndex].checked);
                    }
                }

                if (categoryName === 'Equipment Type') {
                    if (this.formValues[categoryName][filterIndex].name === 'Tanker') {
                      this.$emit('updateTanker', this.formValues[categoryName][filterIndex].checked);
                    }
                }

                if (categoryName === 'Teams') {
                    if (this.formValues[categoryName][filterIndex].name === 'Team') {
                        this.$emit('updateTeam', this.formValues[categoryName][filterIndex].checked);
                    }

                    if (this.formValues[categoryName][filterIndex].checked === true &&
                        this.formValues[categoryName][(!filterIndex * 1)].checked === true)
                    {
                        this.formValues[categoryName][(!filterIndex * 1)].checked = false;
                    }
                }

                if (categoryName === 'Specialization') {
                    if (this.formValues[categoryName][filterIndex].name === 'HazMat') {
                        this.$emit('updateHazmat', this.formValues[categoryName][filterIndex].checked);
                    }
                }
            },
        },
    };
</script>

<style scoped>
    h3 {
        margin: 10px 0 20px 0;
    }

    .indent-1 {
        margin-left: 10px;
    }

    .indent-2 {
        margin-left: 20px;
    }

    .pl-10 {
        padding-left: 10px;
    }

    .pb-10 {
        padding-bottom: 10px;
    }
</style>